import { PageHeader } from '~/components/PageHeader/PageHeader';
import { ErrorBoundary } from '~/components/ErrorBoundary';
import Arts from './Arts';

export function ArtsPage() {
    return (
        <>
            <PageHeader>My Uploads</PageHeader>
            <ErrorBoundary errorMessage="An error occurred while retrieving the uploads">
                <Arts />
            </ErrorBoundary>
        </>
    );
}
